const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AIGeneratorCommandURL: any = {
    Generate: Backofficebff + '/v1/ai-generator/generate',
    GetStatus: (predictionId: string) => Backofficebff + `/v1/ai-generator/status/${predictionId}`,
    Download: (url: string, filename: string, predictionId?: string) =>
        Backofficebff + `/v1/ai-generator/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}${predictionId ? `&predictionId=${predictionId}` : ''}`,
    EnhancePrompt: Backofficebff + '/v1/ai-generator/enhance-prompt',
    MarkAsDownloaded: (predictionId: string) => Backofficebff + `/v1/ai-generator/status/${predictionId}/downloaded`,
};

